import * as React from 'react'

const SvgPowerIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.063 3.587l-.626 1.082a6.875 6.875 0 11-6.874 0l-.625-1.081a8.125 8.125 0 108.125 0zM9.375 1.25h1.25V10h-1.25V1.25z"
      fill="#163250"
    />
  </svg>
)

export default SvgPowerIcon
